/**
 * @module framework/directives/progressive
 */

import { Directive } from 'vue';

import { App } from '~/framework/vue';

const progressiveDirective: Directive<HTMLElement> = {
    mounted($element) {
        function loadImage(): void {
            const imageElement = $element as HTMLImageElement;
            imageElement.addEventListener('load', () =>
                setTimeout(() => {
                    $element.classList.add('loaded');
                }, 100)
            );
            imageElement.src = imageElement.dataset.src ?? imageElement.src;
            imageElement.srcset = imageElement.dataset.srcset ?? imageElement.srcset;
        }

        function handleIntersect(entries: IntersectionObserverEntry[], observer: IntersectionObserver): void {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    loadImage();
                    observer.unobserve($element);
                }
            }
        }

        function createObserver(): void {
            const options: IntersectionObserverInit = {
                root: null, // defaults to the browser viewport
                threshold: 0,
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe($element);
        }

        if (window.IntersectionObserver) {
            createObserver();
        } else {
            loadImage();
        }
    },
};

// Register a global custom directive called `v-progressive`
export const progressive = (app: App) => {
    app.directive('progressive', progressiveDirective);
};
